import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Card,
  Col,
  Row,
  Button,
  Spinner
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import ToggleButton from 'react-toggle-button';
import _ from "lodash";
import {
  fetchSettings,
  updateSettings,
  addFunnelStage,
  addContentProduct,
  addContentIndustry,
  addContentRegion,
  addContentType,
  updateContentType,
  deleteSettingsItem,
  addContentTag,
  updateShortDomain,
  updateAccountAppSettings
} from "../../actions/settings";
import EditTeamItem from "../../components/settings/EditTeamItem";
import TitleEditable from "../../components/TitleEditable";
import ContentItemDraggableList from "../../components/settings/ContentItemDraggableList";
// import CircleCheckBox from "../../components/CircleCheckBox";
import AddContentItemForm from "../../components/settings/AddContentItemForm";
import AddContentTagForm from "../../components/settings/AddContentTagForm";
import DomainAcceptConfirmForm from "../../components/settings/DomainAcceptConfirmForm";
import './TeamSettings.scss';

const ReactSwal = withReactContent(Swal);

class TeamSettings extends Component {
  constructor(props) {
    super(props);

    this.state = {
      shortDomain: ''
    }
  }

  componentDidMount() {
    // From willMount
    this.props.fetchSettings();
    //////
  }

  onEditContentType = (prev, next) => {
    const { contentTypes } = this.props.settings;

    const content = contentTypes[prev];
    delete contentTypes[prev];
    contentTypes[next] = {
      ...content
    };
  }

  handleAddStage = () => {
    ReactSwal.fire({
      allowOutsideClick: true,
      allowEscapeKey: true,
      allowEnterKey: false,
      showCancelButton: false,
      showConfirmButton: false,
      html: (
        <AddContentItemForm
          type="funnel"
          onClose={ReactSwal.clickConfirm}
          onAddContent={this.props.addFunnelStage}
          Analytics={this.props.Analytics}
        />
      )
    })
    .then(result => {
      if (result.value) {
        
      }
    });
  }

  handleAddProduct = () => {
    ReactSwal.fire({
      allowOutsideClick: true,
      allowEscapeKey: true,
      allowEnterKey: false,
      showCancelButton: false,
      showConfirmButton: false,
      html: (
        <AddContentItemForm
          type="product"
          onClose={ReactSwal.clickConfirm}
          onAddContent={this.props.addContentProduct}
          Analytics={this.props.Analytics}
        />
      )
    })
    .then(result => {
      if (result.value) {
        
      }
    });
  }

  handleAddIndustry = () => {
    ReactSwal.fire({
      allowOutsideClick: true,
      allowEscapeKey: true,
      allowEnterKey: false,
      showCancelButton: false,
      showConfirmButton: false,
      html: (
        <AddContentItemForm
          type="industry"
          onClose={ReactSwal.clickConfirm}
          onAddContent={this.props.addContentIndustry}
          Analytics={this.props.Analytics}
        />
      )
    })
    .then(result => {
      if (result.value) {
        
      }
    });
  }

  handleAddRegion = () => {
    ReactSwal.fire({
      allowOutsideClick: true,
      allowEscapeKey: true,
      allowEnterKey: false,
      showCancelButton: false,
      showConfirmButton: false,
      html: (
        <AddContentItemForm
          type="region"
          onClose={ReactSwal.clickConfirm}
          onAddContent={this.props.addContentRegion}
          Analytics={this.props.Analytics}
        />
      )
    })
    .then(result => {
      if (result.value) {
        
      }
    });
  }

  handleAddContentType = () => {
    ReactSwal.fire({
      allowOutsideClick: true,
      allowEscapeKey: true,
      allowEnterKey: false,
      showCancelButton: false,
      showConfirmButton: false,
      html: (
        <AddContentItemForm
          type="type"
          onClose={ReactSwal.clickConfirm}
          onAddContent={this.props.addContentType}
          Analytics={this.props.Analytics}
        />
      )
    })
    .then(result => {
      if (result.value) {
        
      }
    });
  }

  handleAddContentTag = () => {
    ReactSwal.fire({
      allowOutsideClick: true,
      allowEscapeKey: true,
      allowEnterKey: false,
      showCancelButton: false,
      showConfirmButton: false,
      html: (
        <AddContentTagForm
          onClose={ReactSwal.clickConfirm}
          onAddContentTag={this.props.addContentTag}
          contentTagName={this.props.value}
          isEditing={true}
          Analytics={this.props.Analytics}
        />
      )
    })
    .then(result => {
      if (result.value) {
        
      }
    });
  }

  onStageChange = (funnelKeys) => {
    const newFunnelStages = {};
    funnelKeys.forEach((key, index) => {
      // const originalKey = Object.keys(this.props.settings.funnelStages)[index];

      newFunnelStages[key] = {
        ...this.props.settings.funnelStages[key],
        // stage: this.props.settings.funnelStages[originalKey].stage
        stage: index + 1
      }
    });

    this.props.updateSettings(this.props.settings.id, 'funnelStages', newFunnelStages);
  }

  onChangeContentType = (contentTypeKeys) => {
    const newContentTypes = {};
    contentTypeKeys.forEach((key, index) => {
      // const originalKey = Object.keys(this.props.settings.contentTypes)[index];
      
      newContentTypes[key] = {
        ...this.props.settings.contentTypes[key],
        // sort: this.props.settings.contentTypes[originalKey].sort,
        sort: index + 1
      }
    });

    this.props.updateSettings(this.props.settings.id, 'contentTypes', newContentTypes);
  }

  onContentProductChange = (contentProductKeys) => {
    const newContentProducts = {};
    contentProductKeys.forEach((key, index) => {
      // const originalKey = Object.keys(this.props.settings.contentTypes)[index];
      
      newContentProducts[key] = {
        ...this.props.settings.contentProducts[key],
        // sort: this.props.settings.contentTypes[originalKey].sort,
        sort: index + 1
      }
    });

    this.props.updateSettings(this.props.settings.id, 'contentProducts', newContentProducts);
  }

  onContentIndustryChange = (contentIndustryKeys) => {
    const newContentIndustries = {};
    contentIndustryKeys.forEach((key, index) => {
      // const originalKey = Object.keys(this.props.settings.contentTypes)[index];
      
      newContentIndustries[key] = {
        ...this.props.settings.contentIndustries[key],
        // sort: this.props.settings.contentTypes[originalKey].sort,
        sort: index + 1
      }
    });

    this.props.updateSettings(this.props.settings.id, 'contentIndustries', newContentIndustries);
  }

  onContentRegionChange = (contentRegionKeys) => {
    const newContentRegions = {};
    contentRegionKeys.forEach((key, index) => {
      // const originalKey = Object.keys(this.props.settings.contentTypes)[index];
      
      newContentRegions[key] = {
        ...this.props.settings.contentRegions[key],
        // sort: this.props.settings.contentTypes[originalKey].sort,
        sort: index + 1
      }
    });

    this.props.updateSettings(this.props.settings.id, 'contentRegions', newContentRegions);
  }

  updateShortDomain = domain => {
    this.setState({ shortDomain: domain });

    ReactSwal.fire({
      allowOutsideClick: true,
      allowEscapeKey: true,
      allowEnterKey: false,
      showCancelButton: false,
      showConfirmButton: false,
      html: (
        <DomainAcceptConfirmForm
          onClose={ReactSwal.clickCancel}
          onConfirm={ReactSwal.clickConfirm}
        />
      )
    })
    .then(result => {
      if (result.value) {
        this.props.updateShortDomain(
          this.props.settings.id,
          {
            target: this.props.settings.customShortDomain.target,
            protocol: this.props.settings.customShortDomain.protocol,
            domain,
            status: 'unconfirmed'
          }
        ); 
      }
    });
  }

  checkDomain = () => {
    this.setState({ shortDomain: this.props.settings.customShortDomain.domain });

    this.props.updateShortDomain(
      this.props.settings.id,
      {
        domain: this.props.settings.customShortDomain.domain,
        status: 'confirmed'
      }
    );
  }

  render() {
    const {
      contentTypes,
      funnelStages,
      contentTags,
      contentProducts,
      contentIndustries,
      contentRegions,
      isLoading
    } = this.props.settings;

    const isAdmin = _.get(this.props, "cognitoUser.attributes['custom:role']") === 'admin';
    const domainStatus = _.get(this.props.settings, 'customShortDomain.status', 'confirmed');
   
    return (
      <div className="full-width team-settings">
        <Row className="full-width">
          <Col>
            <Row className="full-width">
              <Card bg="light" className="full-width full-height">
                <Card.Header>Funnel Stages</Card.Header>
                <Card.Body>
                  {!isAdmin &&
                    Object.keys(funnelStages)
                      .sort((a, b) => funnelStages[a].stage - funnelStages[b].stage)
                      .map((key, index) => 
                        <div className="d-flex align-items-center pt-2 pb-2 funnel-item" key={`no-admin-${key}`}>
                          {`${funnelStages[key].stage} - ${key}`}
                        </div>
                    )
                  }
                  {isAdmin &&
                    <ContentItemDraggableList
                      contents={funnelStages}
                      onStageChange={this.onStageChange}
                      type="funnel"
                    />
                  }
                  {isAdmin &&
                    <div className="add-content" onClick={this.handleAddStage}>
                      <div className="icon mr-2"><FontAwesomeIcon icon={faPlus} /></div>
                      Add Stage…
                    </div>
                  }
                </Card.Body>
              </Card>
            </Row>
            <Row className="full-width">
              <Card bg="light" className="full-width full-height">
                <Card.Header>Tags</Card.Header>
                <Card.Body>
                  {
                    Object.keys(contentTags)
                      .map(key =>
                        <EditTeamItem
                          key={key}
                          value={key}
                          buttonTitle="EDIT"
                          type="color"
                          contentTag={contentTags[key]}
                          editable={isAdmin}
                        />
                      )
                  }
                  {isAdmin &&
                    <div className="add-content" onClick={this.handleAddContentTag}>
                      <div className="icon mr-2"><FontAwesomeIcon icon={faPlus} /></div>
                      Add tag...
                    </div>
                  }
                </Card.Body>
              </Card>
            </Row>
          </Col>
          <Col>
            <Row className="full-width">
              <Card bg="light" className="full-width full-height">
                <Card.Header>Content Types</Card.Header>
                <Card.Body>
                <ul className="content-types">
                  {!isAdmin &&
                    Object.keys(contentTypes)
                      .sort((a, b) => contentTypes[a].sort - contentTypes[b].sort)
                      .map((key, index) =>
                        <li key={`filter_${index}`} className="d-flex justify-content-between pt-2 pb-2">
                          {/* <CircleCheckBox title={key} /> */}
                          {`${key}`}
                        </li>
                      )
                  }
                  {isAdmin &&
                    <ContentItemDraggableList
                      contents={contentTypes}
                      onStageChange={this.onChangeContentType}
                      type="type"
                    />
                  }
                  {isAdmin &&
                    <li className="add-content" onClick={this.handleAddContentType}>
                      <div className="icon mr-2"><FontAwesomeIcon icon={faPlus} /></div>
                      Add Type...
                    </li>
                  }
                </ul>
                </Card.Body>
              </Card>
            </Row>
            <Row className="full-width">
              <Card bg="light" className="full-width">
                <Card.Header>
                  <div className="flex items-center justify-between">
                    Product
                    { isAdmin && <ToggleButton
                      value={_.get(this.props.settings, 'appOptions.enableProducts', false)}
                      thumbStyle={{ borderRadius: 2 }}
                      trackStyle={{ borderRadius: 2 }}
                      colors={{
                        active: {
                          base: 'rgb(76,210,126)',
                        } 
                      }}
                      onToggle={(value) => {
                        this.props.updateAccountAppSettings({
                          listName: 'appOptions',
                          itemName: 'enableProducts',
                          itemValues: !value
                        });
                      }}
                    />}
                  </div>
                </Card.Header>
                <Card.Body>
                  {!isAdmin &&
                    Object.keys(contentProducts)
                      .sort((a, b) => contentProducts[a].sort - contentProducts[b].sort)
                      .map((key, index) => 
                        <div className="d-flex align-items-center pt-2 pb-2 funnel-item" key={`no-admin-${key}`}>
                          {`${key}`}
                        </div>
                    )
                  }
                  {isAdmin &&
                    <ContentItemDraggableList
                      contents={contentProducts}
                      onStageChange={this.onContentProductChange}
                      type="product"
                    />
                  }
                  {isAdmin &&
                    <div className="add-content" onClick={this.handleAddProduct}>
                      <div className="icon mr-2"><FontAwesomeIcon icon={faPlus} /></div>
                      Add Product…
                    </div>
                  }
                </Card.Body>
              </Card>
            </Row>
            <Row className="full-width">
              <Card bg="light" className="full-width">
                <Card.Header>
                  <div className="flex items-center justify-between">
                    Industry
                    { isAdmin && <ToggleButton
                      value={_.get(this.props.settings, 'appOptions.enableIndustries', false)}
                      thumbStyle={{ borderRadius: 2 }}
                      trackStyle={{ borderRadius: 2 }}
                      colors={{
                        active: {
                          base: 'rgb(76,210,126)',
                        } 
                      }}
                      onToggle={(value) => {
                        this.props.updateAccountAppSettings({
                          listName: 'appOptions',
                          itemName: 'enableIndustries',
                          itemValues: !value
                        });
                      }}
                    />}
                  </div>
                </Card.Header>
                <Card.Body>
                  {!isAdmin &&
                    Object.keys(contentIndustries)
                      .sort((a, b) => contentIndustries[a].sort - contentIndustries[b].sort)
                      .map((key, index) => 
                        <div className="d-flex align-items-center pt-2 pb-2 funnel-item" key={`no-admin-${key}`}>
                          {`${key}`}
                        </div>
                      )
                  }
                  {isAdmin &&
                    <ContentItemDraggableList
                      contents={contentIndustries}
                      onStageChange={this.onContentIndustryChange}
                      type="industry"
                    />
                  }
                  {isAdmin &&
                    <div className="add-content" onClick={this.handleAddIndustry}>
                      <div className="icon mr-2"><FontAwesomeIcon icon={faPlus} /></div>
                      Add Industry…
                    </div>
                  }
                </Card.Body>
              </Card>
            </Row>
            <Row className="full-width">
              <Card bg="light" className="full-width">
                <Card.Header>
                  <div className="flex items-center justify-between">
                    Region
                    { isAdmin && <ToggleButton
                      value={_.get(this.props.settings, 'appOptions.enableRegions', false)}
                      thumbStyle={{ borderRadius: 2 }}
                      trackStyle={{ borderRadius: 2 }}
                      colors={{
                        active: {
                          base: 'rgb(76,210,126)',
                        } 
                      }}
                      onToggle={(value) => {
                        this.props.updateAccountAppSettings({
                          listName: 'appOptions',
                          itemName: 'enableRegions',
                          itemValues: !value
                        });
                      }}
                    />}
                  </div>
                </Card.Header>
                <Card.Body>
                  {!isAdmin &&
                    Object.keys(contentRegions)
                      .sort((a, b) => contentRegions[a].sort - contentRegions[b].sort)
                      .map((key, index) => 
                        <div className="d-flex align-items-center pt-2 pb-2 funnel-item" key={`no-admin-${key}`}>
                          {`${key}`}
                        </div>
                      )
                  }
                  {isAdmin &&
                    <ContentItemDraggableList
                      contents={contentRegions}
                      onStageChange={this.onContentRegionChange}
                      type="region"
                    />
                  }
                  {isAdmin &&
                    <div className="add-content" onClick={this.handleAddRegion}>
                      <div className="icon mr-2"><FontAwesomeIcon icon={faPlus} /></div>
                      Add Region…
                    </div>
                  }
                </Card.Body>
              </Card>
            </Row>
          </Col>
        </Row>
        { isAdmin &&
        <Row className="full-width">
          <Card bg="light" className="full-width">
            <Card.Header id="shortDomain">Short Domain</Card.Header>
            <Card.Body>
              <p>This short domain will be used in the creation of short links for content items that are shared and publicly accessible (the default). You can add a custom domain here to change the domain the short links are shared with</p>
              <div className="d-flex w-100 align-items-center">
                <TitleEditable
                  prepend="Current Domain:"
                  onChange={(value) => this.updateShortDomain(value)}
                  value={isLoading ? this.state.shortDomain : _.get(this.props.settings, 'customShortDomain.domain', '')}
                  editable={!isLoading}
                />
                {isLoading && <Spinner
                  className="ml-1"
                  animation="border"
                  size="sm"
                  variant="info"
                />}
              </div>
              <p className="error-notification">
                {domainStatus === 'unconfirmed' ? 'Domain is not yet confirmed. Please follow instructions then check domain after about 10 minutes. ' : 'New domains may take 10 minutes or longer to take effect. ' }
                <a href="https://learn.contentcamel.io/tutorial/how-to-set-up-a-custom-domain/" target="_blank" rel="noopener noreferrer">Review the instructions.</a>
              </p>
              {domainStatus === 'unconfirmed' &&
                <div className="mt-3">
                  <Button
                    variant="outline-danger"
                    className="btn btn-outline-danger mr-3"
                    onClick={this.checkDomain}
                    disabled={isLoading}
                  >
                    {isLoading && <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                    }
                    CHECK DOMAIN
                  </Button>
                </div>
              }
            </Card.Body>
          </Card>
        </Row>
        }
      </div>
    );
  }
}

const mapStateToProps = state => ({
  settings: state.settings,
  cognitoUser: state.auth.cognitoUser,
  Analytics: state.auth.Analytics
});

const mapDispatchToProps = dispatch => 
bindActionCreators({
  fetchSettings,
  addFunnelStage,
  addContentProduct,
  addContentIndustry,
  addContentRegion,
  updateSettings,
  addContentType,
  updateContentType,
  deleteSettingsItem,
  addContentTag,
  updateShortDomain,
  updateAccountAppSettings
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(TeamSettings);
